import { render } from "./viewLessonDiscuss.vue?vue&type=template&id=7b6bb47c&scoped=true"
import script from "./viewLessonDiscuss.vue?vue&type=script&lang=js"
export * from "./viewLessonDiscuss.vue?vue&type=script&lang=js"

import "./viewLessonDiscuss.vue?vue&type=style&index=0&id=7b6bb47c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6bb47c"]])

export default __exports__